import { render, staticRenderFns } from "./CommonDropdownItems.vue?vue&type=template&id=1958652e"
import script from "./CommonDropdownItems.vue?vue&type=script&lang=js"
export * from "./CommonDropdownItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports